'use strict';

exports.__esModule = true;
exports.menuHelper = menuHelper;

var getItemMenu = function getItemMenu(itemsMenu) {
  var menu = [];
  itemsMenu.map(function (item) {
    if (item.listaAccesosHijos) {
      menu[menu.length] = {
        label: item.nomEtiqueta,
        icon: 'fa fa-fw fa-bars',
        items: getItemMenu(item.listaAccesosHijos)
      };
    } else {
      menu[menu.length] = {
        label: item.nomEtiqueta,
        command: function command() {
          window.location = item.txtUrl;
        }
      };
    }
  });
  return menu;
};

function menuHelper(itemsMenu) {
  return getItemMenu(itemsMenu);
}